import {BaseStage} from "./BaseStage";

class ShowSelectStage extends BaseStage {


    constructor(globalState) {
        super(globalState);

        this.domContainer = document.querySelector(`.stage.${this.getStageKey()}`)

        // Setup show select cards
        this.domContainer.querySelectorAll('.show').forEach(showContainer => {
            const showInput = showContainer.querySelector(`input`);

            showInput.addEventListener('change', () => {
                this.handleShowSelect(showContainer);
            })

            // Trigger show selection
            showContainer.addEventListener('click', () => {
                showInput.checked = true;
                showInput.dispatchEvent(new InputEvent('change'));
            })
        })

        // Run base class initializations
        this.initSharedComponents();
    }

    /**
     * @return {PublicTicketsFormDefs.Stage}
     */
    getStageKey() {
        // noinspection JSValidateTypes
        return 'show-select';
    }

    /**
     * @param {HTMLElement} showContainer
     */
    handleShowSelect(showContainer) {
        /** @var {HTMLInputElement} */
        const showInput = showContainer.querySelector(`input`);

        // Clear all other shows from selection
        this.domContainer.querySelectorAll('.show').forEach(show => {
            show.classList.remove('selected');
            show.querySelector('input').checked = false;
        })

        // Mark show as selected
        showInput.checked = true;
        // And add selected class
        showContainer.classList.add('selected');

        // Store selected event
        this.globalState.setParentEvent(JSON.parse(showInput.dataset.event));

        this.enableNextStageButton();
    }
}

export {ShowSelectStage};
